import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError, formatEuro } from "@/lib/api";

export const AdminDisputes = ({ open }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/disputes").then((r) => setItems(r.data)).catch(() => {}), []);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const decide = async (id, decision) => {
    try {
      await api.post(`/admin/disputes/${id}`, { decision });
      toast.success(decision === "refund" ? "Corsa annullata e rimborsata" : "Annullamento respinto");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  if (!items.length) return <p data-testid="admin-disputes-empty" className="mt-6 text-sm text-[#94A3B8]">Nessun contenzioso aperto.</p>;
  return (
    <div className="mt-6 flex flex-col gap-3" data-testid="admin-disputes">
      <span className="ff-label !mb-0">Contenziosi aperti ({items.length})</span>
      {items.map((d) => (
        <div key={d.id} data-testid={`admin-dispute-${d.id}`} className="ff-card p-4 flex flex-col gap-2 border-orange-500/60">
          <span className="font-bold text-white">{d.origin} ➔ {d.destination} • {formatEuro(d.fare)}</span>
          <span className="text-sm text-[#CBD5E1]">{d.escrow_ref} • ritiro {d.pickup_at.replace("T", " ")}</span>
          <span className="text-sm text-[#CBD5E1]">Cedente: {d.cedente} • Esecutore: {d.esecutore}</span>
          <span className="text-sm text-amber-300">Richiesto da {d.requested_by}: {d.reason}{d.note ? ` — ${d.note}` : ""}</span>
          <div className="grid grid-cols-2 gap-2 mt-1">
            <button type="button" data-testid={`admin-dispute-refund-${d.id}`} onClick={() => decide(d.id, "refund")} className="ff-btn-secondary !min-h-[48px] text-sm border-[#10B981]">Annulla e rimborsa</button>
            <button type="button" data-testid={`admin-dispute-keep-${d.id}`} onClick={() => decide(d.id, "keep")} className="ff-btn-secondary !min-h-[48px] text-sm border-red-500 text-red-300">Respingi</button>
          </div>
        </div>
      ))}
    </div>
  );
};
